import React from "react";
import { List, ListItem } from "@mui/material";
import { Draggable, Droppable } from "@hello-pangea/dnd";
import _ from "lodash";
import attachmentMergeCombinableStyle from "./attachmentMergeCombinableStyle.ts";
import { WarningOutlined } from "@mui/icons-material";
import { MediaObject } from "../../types/MediaObject.ts";

type AttachmentMergeDroppableProps = {
  combinable: Array<number>;
  index: number | string;
  backgroundImage?: string;
  mediaObjects: Array<MediaObject>
};

export default function AttachmentMergeDroppable({ combinable, index, backgroundImage, mediaObjects }: AttachmentMergeDroppableProps) {
  //for dev use StrictModeDroppable instead of Droppable
  return (
    <Droppable droppableId={"" + index}>
      {(provided) => (
        <List
          {...provided.droppableProps}
          ref={provided.innerRef}
          sx={
            backgroundImage
              ? {
                  ...attachmentMergeCombinableStyle.combinableList,
                  backgroundImage: "url(" + backgroundImage + ")",
                }
              : attachmentMergeCombinableStyle.combinableList
          }
        >
          {_.map(combinable, (mediaObjectId, index) => (
            <Draggable draggableId={"attachment-" + mediaObjectId} index={index} key={mediaObjectId}>
              {(provided) => (
                <ListItem
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  ref={provided.innerRef}
                  sx={attachmentMergeCombinableStyle.combinableListItem}
                >
                  {mediaObjectId === 0 && <WarningOutlined sx={{ color: "red" }} />}
                  {mediaObjects.find(mediaObject => mediaObject.id === mediaObjectId)?.originalName}
                </ListItem>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </List>
      )}
    </Droppable>
  );
}
